// Notepad / Notes — only real backend fields (notepadSchema + /api/notepad/notes).
// The frontend NEVER sends user_id / created_at / _id (NP-1 hardening; backend
// mass-assignment defect is documented for the stabilization patch, not exploited).

export type AccessControl = 'private' | 'user' | 'department';

export interface Note {
  id: string;
  title: string;
  notebookText?: string;
  /** Stored by the backend but not edited in this phase (round-tripped untouched). */
  elements?: unknown[];
  drawing?: string;
  access_control: AccessControl;
  /** ObjectId strings of users a `user`-scoped note is shared with. */
  shared_with_users?: string[];
  /** Department keys a `department`-scoped note is shared with. */
  shared_with_depts?: string[];
  /** Owner display name (backend-populated). */
  author_name?: string;
  /** Owner — populated object in list responses; id string in mutation responses. */
  user_id?: string | { _id?: string; id?: string; display_name?: string };
  created_at?: string;
  updated_at?: string;
}

/** ONLY editable fields are ever submitted. */
export interface SaveNotePayload {
  title: string;
  notebookText?: string;
  access_control: AccessControl;
  shared_with_users?: string[];
  shared_with_depts?: string[];
}

/** Robustly extract the owner id whether `user_id` is populated or a raw id. */
export function getOwnerId(u: Note['user_id']): string {
  if (!u) return '';
  if (typeof u === 'string') return u;
  return u.id ?? u._id ?? '';
}
